import { trackSignupFlowStep } from "../datadogRum";

// Thin wrapper ensuring analytics never throw and allowing optional debug logging.
export function safeTrack(step: string, payload: Record<string, unknown> = {}) {
  try {
    trackSignupFlowStep(step, payload);
  } catch (e) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.warn("Tracking failed for step", step, e);
    }
  }
}
